import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { CardMenuComponent } from './card-menu/card-menu.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SortableColumnLabelComponent } from './sortable-column-label/sortable-column-label.component';
import { ExcelExportButtonComponent } from './excel-export-button/excel-export-button.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { BooleanToStringPipe } from './boolean.pipe';
import { FileSizePipe } from './filesize.pipe';
import { NullableCurrencyPipe } from './nullableCurrency.pipe';
import { NullableNumberPipe } from './nullableNumber.pipe';
import { PhoneNumberPipe } from './phone.pipe';
import { UtcToLocalPipe } from './utcToLocal.pipe';
import { ExpandingTextAreaComponent } from './expanding-text-area/expanding-text-area.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { NumericRangePickerComponent } from './numeric-range-picker/numeric-range-picker.component';
import { AddressSubformComponent } from './address-subform/address-subform.component';
import { RetailerWholesalerSelectorComponent } from './retailer-wholesaler-selector/retailer-wholesaler-selector.component';
import { ViewAddressComponent } from './view-address/view-address.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ReturnToHomeButtonComponent } from './return-to-home-button/return-to-home-button.component';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
@NgModule({
  declarations: [
    CardMenuComponent,
    ExcelExportButtonComponent,
    LoadingIndicatorComponent,
    SortableColumnLabelComponent,
    BooleanToStringPipe,
    FileSizePipe,
    NullableCurrencyPipe,
    NullableNumberPipe,
    PhoneNumberPipe,
    UtcToLocalPipe,
    ExpandingTextAreaComponent,
    DateRangePickerComponent,
    NumericRangePickerComponent,
    AddressSubformComponent,
    RetailerWholesalerSelectorComponent,
    ViewAddressComponent,
    ConfirmModalComponent,
    ReturnToHomeButtonComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    RouterModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    RouterModule,
    CardMenuComponent,
    ExcelExportButtonComponent,
    LoadingIndicatorComponent,
    SortableColumnLabelComponent,
    ExpandingTextAreaComponent,
    BooleanToStringPipe,
    NullableCurrencyPipe,
    NullableNumberPipe,
    PhoneNumberPipe,
    UtcToLocalPipe,
    ExpandingTextAreaComponent,
    DateRangePickerComponent,
    NumericRangePickerComponent,
    AddressSubformComponent,
    RetailerWholesalerSelectorComponent,
    ViewAddressComponent,
    ConfirmModalComponent,
    ReturnToHomeButtonComponent,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  providers: [provideEnvironmentNgxMask()],
})
export class SharedModule {}
